import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import {
  AllocationViewRestoreAction,
  AllocationViewRestoreActionSetInitialState,
} from './allocation-view-restore-action.actions';
import { AllocationViewRestoreActionService } from './allocation-view-restore-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewRestoreActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewRestoreActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsRestore',
  defaults: initialState,
})
@Injectable()
export class AllocationViewRestoreActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewRestoreActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewRestoreActionService: AllocationViewRestoreActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewRestoreAction)
  uliRestore(
    ctx: StateContext<AllocationViewRestoreActionStateModel>,
    { payload: { identifier } }: AllocationViewRestoreAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewRestoreActionService.uliRestore(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.restore');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewRestoreActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewRestoreActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
